import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { weddingContent } from "../../components/Wedding/content";
import { Wishes } from "../../components/Wedding/Wishes";
import { GuestCameraPhotos } from "../../components/Wedding/GuestCameraPhotos";
import WeddingInvitationSchedule, { dressCodeColors, weddingTimelineEvents } from "./WeddingInvitationSchedule";
import InvitationDivider from "../../components/Wedding/InvitationDivider";
import "../../components/Wedding/wedding.css";
import detailsEnvelopeBack from "../../assets/img/invitation-envelope-back.png";
import detailsEnvelopeFront from "../../assets/img/invitation-envelope-front.png";
import detailsCard from "../../assets/img/invitation-ornate-card.png";
import lace from "../../assets/img/invitation-details-lace.png";
import heart from "../../assets/img/invitation-details-heart.png";
import strip from "../../assets/img/invitation-photo-strip.png";
import rsvp from "../../assets/img/invitation-rsvp-card.png";
import story from "../../assets/img/invitation-story-card.png";
import frame from "../../assets/img/wedding-photobooth-frame.png";
import smallFlower from "../../assets/img/invitation-small-flower.png";
import stem from "../../assets/img/invitation-flower-stem.png";
import leaf from "../../assets/img/invitation-flower-leaf.png";
import calla from "../../assets/img/invitation-tall-calla.png";
import polaroid from "../../assets/img/invitation-small-photo.png";
import together from "../../assets/img/wedding-photobooth-together.jpg";
import kiss from "../../assets/img/wedding-photobooth-kiss.jpg";
import travel from "../../assets/img/our-moment-02.jpg";
import monogram from "../../assets/img/wedding-monogram-white.png";
import "./WeddingInvitationEnding.css";
import { useInvitationLanguage } from "./InvitationLanguage";

const celebrationTime = new Date("2027-01-17T18:00:00+07:00").getTime();

const googleCalendarUrl = `https://calendar.google.com/calendar/render?${new URLSearchParams({
  action: "TEMPLATE",
  text: "Hương & Lượng wedding",
  dates: "20270117T103000Z/20270117T103000Z",
  ctz: "Asia/Ho_Chi_Minh",
})}`;

export function getInvitationCountdown(now = Date.now()) {
  const seconds = Math.max(0, Math.floor((celebrationTime - now) / 1000));
  return [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
}

function InvitationCountdown() {
  const { t } = useInvitationLanguage();
  const [remaining, setRemaining] = useState(() => getInvitationCountdown());
  useEffect(() => {
    const timer = window.setInterval(() => setRemaining(getInvitationCountdown()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className="invitation-ending__countdown" role="timer" aria-label={t("Countdown to 17 January 2027, 18:00 Vietnam time", "Đếm ngược đến 18 giờ ngày 17 tháng 01 năm 2027, giờ Việt Nam")}>
      {remaining.map((value, index) => (
        <div key={index}>
          <span className="invitation-ending__number">{String(value).padStart(2, "0")}</span>
          <span className="invitation-ending__unit">{[t("DAYS", "NGÀY"), t("HOURS", "GIỜ"), t("MINUTES", "PHÚT"), t("SECONDS", "GIÂY")][index]}</span>
        </div>
      ))}
    </div>
  );
}

export default function WeddingInvitationEnding() {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const { language, t } = useInvitationLanguage();
  const details = weddingContent[language].details;

  return (
    <>
      <div className="invitation-ending" aria-label={t("Wedding details and our story", "Thông tin lễ cưới và chuyện chúng mình")}>
        <button type="button" className="invitation-ending__details" aria-label={t("The Details", "Thông tin")} onClick={() => dialogRef.current?.showModal()}>
          <img className="invitation-ending__lace" src={lace} alt="" loading="lazy" />
          <img className="invitation-ending__heart" src={heart} alt="" loading="lazy" />
          <span className="invitation-ending__details-title">{t("The Details", "Thông tin")}</span>
          <span className="invitation-ending__details-prompt">{t("CLICK HERE", "XEM THÊM")}</span>
        </button>

        <img className="invitation-ending__stem invitation-ending__stem--right" src={stem} alt="" loading="lazy" />
        <img className="invitation-ending__leaf invitation-ending__leaf--right" src={leaf} alt="" loading="lazy" />
        <figure className="invitation-ending__strip">
          <img className="invitation-ending__strip-frame" src={strip} alt="" loading="lazy" />
          <img className="invitation-ending__strip-photo invitation-ending__strip-photo--one" src={together} alt={t("Hương and Lượng in traditional Vietnamese attire", "Hương và Lượng trong tà áo dài")} loading="lazy" />
          <img className="invitation-ending__strip-photo invitation-ending__strip-photo--two" src={kiss} alt={t("A kiss between the happy couple", "Nụ hôn của đôi uyên ương")} loading="lazy" />
          <img className="invitation-ending__strip-photo invitation-ending__strip-photo--three" src={travel} alt={t("Hương and Lượng on their trip to Sydney", "Hương và Lượng trong chuyến đi Sydney")} loading="lazy" />
        </figure>

        <div className="invitation-ending__rsvp-frame" aria-hidden="true"><img src={frame} alt="" loading="lazy" /></div>
        <div className="invitation-ending__rsvp" aria-label={t("Kindly RSVP — coming soon", "Xác nhận tham dự — sắp cập nhật")}>
          <img src={rsvp} alt="" loading="lazy" />
          <div className="invitation-ending__rsvp-copy">
            <h2>{t("Kindly", "Xác nhận")}<br />{t("RSVP", "tham dự")}</h2>
            <p>{t("COMING SOON", "SẮP CẬP NHẬT")}</p>
          </div>
        </div>
        <img className="invitation-ending__small-flower" src={smallFlower} alt="" loading="lazy" />
        <img className="invitation-ending__calla" src={calla} alt="" loading="lazy" />

        <img className="invitation-ending__stem invitation-ending__stem--left" src={stem} alt="" loading="lazy" />
        <img className="invitation-ending__leaf invitation-ending__leaf--left" src={leaf} alt="" loading="lazy" />
        <figure className="invitation-ending__polaroid">
          <img className="invitation-ending__polaroid-photo" src={kiss} alt={t("A happy moment with Hương and Lượng", "Khoảnh khắc hạnh phúc của Hương và Lượng")} loading="lazy" />
          <img className="invitation-ending__polaroid-frame" src={polaroid} alt="" loading="lazy" />
        </figure>
        <Link className="invitation-ending__story" to={language === "vi" ? "/tramnamhanhphuc?lang=vi" : "/tramnamhanhphuc"} aria-label={t("Our Love Story", "Chuyện chúng mình")} onClick={() => window.scrollTo(0, 0)}>
          <img src={story} alt="" loading="lazy" />
          <div className="invitation-ending__story-copy"><h2>{t("Our", "Chuyện")}<br />{t("Love Story", "chúng mình")}</h2><span>{t("CLICK HERE", "XEM THÊM")}</span></div>
        </Link>
      </div>

      <InvitationDivider />
      <footer className="invitation-ending__footer">
        <h2>{t("The countdown is on!", "Cùng đếm ngược đến ngày chung đôi!")}</h2>
        <InvitationCountdown />
        <div className="invitation-ending__guest-actions">
          <p className="invitation-ending__date"><time dateTime="2027-01-17">{weddingContent[language].hero.date}</time></p>
          <p className="invitation-ending__weekday">{t("(Sunday)", "(Chủ nhật)")}</p>
          <a className="invitation-ending__venue" href={details.directionsUrl} target="_blank" rel="noreferrer">{weddingContent[language].hero.location}</a>
        </div>
        <p className="invitation-ending__welcome">{t("We and our families look forward to celebrating with you. For any questions, please contact us directly.", "Chúng mình và gia đình rất mong được đón bạn đến chung vui. Nếu cần thêm thông tin, hãy liên hệ trực tiếp với chúng mình nhé.")}</p>
        <p className="invitation-ending__with-love">{t("WITH LOVE", "THƯƠNG MẾN")}</p>
        <p className="invitation-ending__signature">Hương &amp; Lượng</p>
        <img className="invitation-ending__logo" src={monogram} alt={t("Hương & Lượng wedding monogram", "Logo cưới Hương và Lượng")} loading="lazy" />
      </footer>

      <div className="invitation-ending__buttons">
        <button type="button" className="invitation-ending__action" onClick={() => document.getElementById("wishes")?.scrollIntoView({ behavior: "smooth" })}>{weddingContent[language].hero.cta}</button>
        <button type="button" className="invitation-ending__action invitation-ending__action--outline" onClick={() => document.getElementById("guest-photos")?.scrollIntoView({ behavior: "smooth" })}>{weddingContent[language].hero.guestPhotosCta}</button>
      </div>

      <div className="invitation-guest-sections">
        <WeddingInvitationSchedule />
        <div className="invitation-ending__wishes-divider" aria-hidden="true">
          <span className="invitation-ending__wishes-logo" />
        </div>
        <Wishes language={language} />
        <GuestCameraPhotos language={language} />
        <section className="invitation-ending__thank-you" aria-labelledby="invitation-thank-you-title">
          <h2 id="invitation-thank-you-title">{t("Thank You", "Cảm ơn bạn")}</h2>
          <p>{t("Thank you for sharing in our joy. Your love, wishes and presence make this day even more special to us.", "Cảm ơn bạn đã chung vui cùng chúng mình. Tình cảm, những lời chúc và sự hiện diện của bạn khiến ngày chung đôi thêm trọn vẹn.")}</p>
          <p className="invitation-ending__thank-you-signature">Hương &amp; Lượng</p>
          <img className="invitation-ending__logo" src={monogram} alt={t("Hương & Lượng wedding monogram", "Logo cưới Hương và Lượng")} loading="lazy" />
        </section>
      </div>

      <dialog ref={dialogRef} className="invitation-day-details" aria-labelledby="invitation-day-details-title" onClick={(event) => { if (event.target === event.currentTarget) dialogRef.current?.close(); }}>
        <img className="invitation-day-details__envelope-back" src={detailsEnvelopeBack} alt="" aria-hidden="true" />
        <img className="invitation-day-details__card" src={detailsCard} alt="" aria-hidden="true" />
        <img className="invitation-day-details__envelope-front" src={detailsEnvelopeFront} alt="" aria-hidden="true" />
        <button className="invitation-day-details__close" type="button" aria-label={t("Close wedding details", "Đóng thông tin lễ cưới")} onClick={() => dialogRef.current?.close()}>×</button>
        <div className="invitation-day-details__content">
        <h2 id="invitation-day-details-title">{t("The Details", "Thông tin")}</h2>
        <p className="invitation-day-details__date"><time dateTime="2027-01-17">{details.detailsSoon}</time></p>
        <h3 className="invitation-day-details__venue">{details.receptionVenue}</h3>
        <p className="invitation-day-details__address">{t("(59 Vo Van Kiet, An Lac ward, HCM city)", "(59 Võ Văn Kiệt, phường An Lạc, TP. HCM)")}</p>
        <a href={details.directionsUrl} target="_blank" rel="noreferrer">{details.directionsSoon} ↗</a>
        <ol className="invitation-day-details__timeline" aria-label={t("Wedding highlights", "Các mốc chính trong ngày cưới")}>
          {weddingTimelineEvents.filter(({ title }) => ["Welcome & Photos", "Wedding Ceremony", "After Party"].includes(title)).map(({ time, title, titleVi, graphic }) => (
            <li key={time}>
              <span className="invitation-day-details__timeline-icon" style={{ maskImage: `url(${graphic})`, WebkitMaskImage: `url(${graphic})` }} aria-hidden="true" />
              <span className="invitation-day-details__timeline-dot" aria-hidden="true" />
              <time dateTime={`2027-01-17T${time}:00+07:00`}>{time}</time>
              <span className="invitation-day-details__timeline-label">{t(title, titleVi)}</span>
            </li>
          ))}
        </ol>
        <h3>{details.dressCode}</h3>
        <ul className="invitation-day-details__palette" aria-label={t("Dress code colors", "Màu trang phục")}>
          {dressCodeColors.map(({ name, nameVi, color }) => (
            <li key={name}>
              <span role="img" aria-label={t(name, nameVi)} style={{ backgroundColor: color }} />
            </li>
          ))}
        </ul>
        </div>
        <details className="invitation-day-details__calendar">
          <summary><span>{t("Add to Calendar", "Thêm vào lịch")}</span><small>{t("CLICK HERE", "XEM THÊM")}</small></summary>
          <div className="invitation-day-details__calendar-options">
            <a href={googleCalendarUrl} target="_blank" rel="noreferrer">Google Calendar ↗</a>
            <a href={`${process.env.PUBLIC_URL}/huong-luong-wedding.ics`} download="huong-luong-wedding.ics">Apple / Outlook (.ics)</a>
          </div>
        </details>
      </dialog>
    </>
  );
}
